import * as React from "react";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../stores/seekerStore";
import ProfileStore from "../../stores/profileStore";
import { Demographics, WorkExperience, Language, EducationExperience, IReference } from "../../models/profile";
import { JobType, BusyEvent } from "../../models/enums";
import { IResumeLocalization, ILocalization } from "../../models/localization";
import { ParsedResumeResults } from "../../models/parsedResumeResults";
import { Grid, Row, Col } from "react-flexbox-grid";
import BackButton from "../../components/widgets/backBtn";
import Busy from "../../components/widgets/busy";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";
import DropZone from "react-dropzone";
import WorkExperienceEditor from "../../components/profile/workExperienceEditor";
import MilitaryExperienceEditor from "../../components/profile/militaryExperienceEditor";
import EducationExperienceEditor from "../../components/profile/educationExperienceEditor";
import LangEditor from "../../components/profile/langEditor";
import * as s from "./import.css";

class MapperSummary extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    const ps: ProfileStore = this.props.store.profileStore;
    const resumeLocal: IResumeLocalization = this.props.store.localization.fields.resume;
    const local: ILocalization = this.props.store.localization.fields;

    return <div>
      <h4 className={s.blueHeader}>{resumeLocal.confirm}</h4>
     <Row className={s.rowMargin}>
        <Col xs={12} className={s.injectedText}>
          <div><p>{resumeLocal.addingPrefix} {ps.selectedJobs.length} {local.of} {ps.resumeData.jobs.length} {resumeLocal.addWorkExpSuffix}</p></div>
          <div><p>{resumeLocal.addingPrefix} {ps.selectedEds.length} {local.of} {ps.resumeData.educations.length} {resumeLocal.addEdExpSuffix}</p></div>
          <div><p>{resumeLocal.addingPrefix} {ps.selectedLangs.length} {local.of} {ps.resumeData.languages.length} {resumeLocal.addLangSuffix}</p></div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} >
          <div style={{ marginTop: "12px", textAlign: "center" }}>
            <Button onClick={ps.decrementParseStep} raised color="secondary" aria-label="add">{resumeLocal.prev}</Button>
            <span>&nbsp;&nbsp;</span>
            <Button onClick={ps.saveResumeImport} raised color="secondary" aria-label="add">{resumeLocal.save}</Button>
          </div>
        </Col>
      </Row>
      </div>;
  }
}

@inject("store") @observer
export default class ResumeImportVw extends React.Component<{ store: SeekerStore }, {}> {
  @observable resumeFile: File;
  constructor(props: any) {
    super(props);
    this.resumeFile = null;
  }
  @action handleFile = (accepted: File[], rejected: File[]): void => {
    if (accepted && accepted.length > 0) {
      this.resumeFile = accepted[0];
    }
  }
  componentWillMount(): void {
    if (!this.props.store.viewState.requireAuthentication()) {
      return;
    }
    this.props.store.profileStore.resetParsing();
  }
  uploadResume = (): void => {
    this.props.store.profileStore.uploadResume(this.resumeFile);
  }
  render(): JSX.Element {
      if (!this.props.store.profileStore.profile) {
          return null;
      }
      const demo: Demographics = this.props.store.profileStore.profile.demographics;
      const local: IResumeLocalization = this.props.store.localization.fields.resume;
      if (!demo || !local) {
          return null;
      }
      const rd: ParsedResumeResults = this.props.store.profileStore.resumeData;
      const hasData: boolean = (rd && rd.jobs.length + rd.educations.length + rd.languages.length > 0);
      const step: number = this.props.store.profileStore.parseStep;
      let we: WorkExperience = null;
      let ed: EducationExperience = null;
      let lang: Array<Language> = null;
      if (this.props.store.profileStore.resumeSrc instanceof WorkExperience) {
          we = this.props.store.profileStore.resumeSrc as WorkExperience;
      } else if (this.props.store.profileStore.resumeSrc instanceof EducationExperience) {
          ed = this.props.store.profileStore.resumeSrc as EducationExperience;
      } else if (this.props.store.profileStore.resumeSrc instanceof Array) {
          lang = this.props.store.profileStore.resumeSrc as Array<Language>;
      }

    return (
      <div>
        <BackButton />
        <Grid className={s.container}>        
          <Row>
            <Col xs={12}>
              {step < 2 && <h4 className={s.blueHeader}>{local.step1Title}</h4>}
              {we !== null && we.expType === JobType.Work && <h4>{local.jobFound}</h4>}
              {we !== null && we.expType === JobType.Military && <h4>{local.milFound}</h4>}
              {ed !== null && <h4>{local.edFound}</h4>}
              {lang !== null && <h4>{local.langFound}</h4>}
            </Col>
          </Row>
          {step === 1 && <div>
            <Row>
              <Col xs={12}>
                <div dangerouslySetInnerHTML={{ __html: local.step1Text }}></div>
              </Col>
            </Row>
            <Row className={s.rowMargin}>
              <Col xs={12} sm={6} md={6} lg={6} xl={4} className={s.injectedText}>
                <DropZone className={s.uploadBackground} onDrop={this.handleFile} accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,text/plain,text/html"
                  style={{ width: "100%", height: "75px", border: "1px dashed #5B6770" }}>
                  {!this.resumeFile && <p className={s.uploadText}>{local.dropMsg}</p>}
                  {this.resumeFile && <p className={s.uploadText}>{this.resumeFile.name}</p>}
                </DropZone>
                <br />
                <Button disabled={this.resumeFile === null} onClick={this.uploadResume} raised color="secondary" aria-label="add">{local.uploadBtn}</Button>
                <div style={{ textAlign: "center" }}><Busy show={this.props.store.viewState.isBusy(BusyEvent.ParseResume)} size="sm" msg={local.uploadMsg} /></div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6} xl={4} className={s.injectedText}>
                {rd !== null && <div>
                  <div style={{ fontSize: "1.5em" }}><h4 className={s.blueHeader}>{local.step2Title}</h4></div>
                  {rd.jobs.length > 0 && <div><p>{`${local.workExpPrefix}${(rd.jobs.length + rd.existingJobs).toString()}`}{rd.existingJobs > 0 && ` (${rd.existingJobs} ${local.expSuffix}`}</p></div>}
                  {rd.educations.length > 0 && <div><p>{`${local.edExpPrefix}${(rd.educations.length + rd.existingEducations).toString()}`}{rd.existingEducations > 0 && ` (${rd.existingEducations} ${local.expSuffix}`}</p></div>}
                  {rd.languages.length > 0 && <div><p>{`${local.langExpPrefix}${(rd.languages.length + rd.existingLanguages).toString()}`}{rd.existingLanguages > 0 && ` (${rd.existingLanguages} ${local.expSuffix}`}</p></div>}
                  {!hasData && <div><p>{local.nothingFound}</p></div>}
                  <br />
                  {hasData && <Button onClick={this.props.store.profileStore.incrementParseStep} raised color="secondary" aria-label="add">{local.next}</Button>}
                </div>}
              </Col>
            </Row>
          </div>}
          {we && we.expType === JobType.Work && <WorkExperienceEditor store={this.props.store} exp={we} fromResume={true} />}
          {we && we.expType === JobType.Military && <MilitaryExperienceEditor store={this.props.store} exp={we} fromResume={true} />}
          {ed && <EducationExperienceEditor store={this.props.store} exp={ed} fromResume={true} />}
          {lang && <LangEditor store={this.props.store} fromResume={true} />}
          {!this.props.store.profileStore.resumeSrc && this.props.store.profileStore.parseStep > 1 && <MapperSummary store={this.props.store} />}
        </Grid>
        <br />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/resumeImport/index.tsx